import React from 'react';
import { LotContext, LotContextProps } from '../context/LotContext';
import { Lot } from '../types/lot/lot';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const lotState = {
  items: new Map<string, Lot>(),
  loading: false,
};

export const lotSlice = createSlice({
  name: 'lot',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      lotState.items = new Map();
      lotState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<Lot[]>) => {
      lotState.items = new Map();
      action.payload.forEach(p => lotState.items.set(p.id, new Lot(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<Lot[]>) => {
      action.payload.forEach(p => lotState.items.set(p.id, new Lot(p)));
      lotState.items = new Map(lotState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<Lot[]>) => {
      action.payload.forEach(p => lotState.items.delete(p.id));
      lotState.items = new Map(lotState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      lotState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface LotProviderProps {
  children: React.ReactNode;
}

export default function LotProvider({ children }: LotProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.lots.key);

  const lotContext: LotContextProps = {
    lots: lotState.items,
    lotsLoading: lotState.loading,
    setLots: (lot: Map<string, Lot>) => {
      dispatch(lotSlice.actions.set([...lot.values()]));
    },
  };

  return <LotContext.Provider value={lotContext}>{children}</LotContext.Provider>;
}
